module.exports = __webpack_public_path__ + "08_mole.243b3bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/08_mole.png
// module id = uU38
// module chunks = 0